///将内容复制到剪切板
const copyToClipboard = (value) => {
    if (value) {
        let tempInput = document.createElement("textarea");
        tempInput.value = value;
        document.body.appendChild(tempInput);
        tempInput.select();
        tempInput.setSelectionRange(0, 99999); // 对于移动设备
        document.execCommand("copy");
        document.body.removeChild(tempInput);
        return true;
    }
    return false;
}

///字符串拆分
export const subString = (content, splitter) => {
    if (splitter.length <= 0) {
        return [content]
    }
    return content.split(splitter)
}

///用户名和密码格式验证
function isValidUsername(username) {
    // 判断用户名是否为空
    if (!username) {
        return false;
    }

    // 使用正则表达式判断用户名是否满足条件
    // ^\w{6,12}$: 匹配6到12个字符长度的字符串，这些字符可以是字母、数字或下划线
    // ^\d+$: 匹配全是数字的字符串
    const regex = /^\w{6,12}$/;
    const allDigitsRegex = /^\d+$/;
    return regex.test(username) && !allDigitsRegex.test(username);
}

function isValidNickName(nickName) {
    // 判断用户名是否为空
    if (!nickName) {
        return true;
    }

    // 使用正则表达式判断用户名是否满足条件
    // ^[a-zA-Z0-9_\u4e00-\u9fa5]{6,12}$: 长度在6到12个字符之间，包含英文、数字、下划线和中文字符
    // ^\d+$: 全是数字
    const regex = /^[a-zA-Z0-9_\u4e00-\u9fa5]{3,7}$/;
    const allDigitsRegex = /^\d+$/;
    return regex.test(nickName) && !allDigitsRegex.test(nickName);
}



export default {
    copyToClipboard,
    subString,
    isValidUsername,
    isValidNickName
}